<app-group-header [Heading]="'Distanz'"
				  [chart]="chart"
				  [info]="info"
				  [noChart]="true"
				  (chartEvent)="getChartEvent($event)"
				  (infoEvent)="getInfoEvent($event)">
</app-group-header>

<div class="card-group">

	<app-default-card class="card" style="border: none; border-radius: unset;"
					  [Heading]="'Distanz leer'"
					  [Error]="distanceEmpty?.isError"
					  [ErrorLevel]="distanceEmpty?.status"
					  [showChart]="chart"
					  [showInfo]="info"
					  [Values]="[distanceEmpty?.TimeseriesData]"
					  [Legend]="['Distanz leer']"
                      [Unit]="'km'"
					  [Info]="'Zurückgelegte Distanz im Leerbetrieb.'"
					  [resizeEvent]="childResizeEvent">
	</app-default-card>

	<app-default-card class="card" style="border: none; border-radius: unset;"
					  [Heading]="'Distanz beladen'"
					  [Error]="distanceLoaded?.isError"
					  [ErrorLevel]="distanceLoaded?.status"
					  [showChart]="chart"
					  [showInfo]="info"
					  [Values]="[distanceLoaded?.TimeseriesData]"
					  [Legend]="['Distanz beladen']"
                      [Unit]="'km'"
					  [Info]="'Zurückgelegte Distanz im beladenen Zustand.'"
					  [resizeEvent]="childResizeEvent">
	</app-default-card>

</div>
